<template>
    <div>

        <div style="display: flex;justify-content: center;">
            <div style="width: 1520px;">
                <div style="text-align: left;margin-top: 20px;">
                    <el-breadcrumb separator="/" style="padding-bottom: 20px;font-size: 18px!important;">
                        <el-breadcrumb-item :to="{ path: '/enterprise/home' }" style="color: #FFFFFF;">首页
                        </el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/combinedQuery/combinedForm' }">组合查询</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>

                <div class="tab-center" style="font-size: 16px;">
                    <div class="normal" style="text-align: center;padding: 12px 20px;"
                        :class="typeIndex===index&&'active'" @click="selectType({item,index})"
                        v-for="(item,index) in typeList" :key="index">{{item.name}}</div>

                </div>

                <div style="margin-bottom: 20px;">
                    <div style="display: flex;">
                        <div class="queryBox" style="width: 1000px;">


                            <div class="scrollViewY" id="scrollViewY">
                                <div id="tabContent0"></div>
                                <div style="margin-bottom: 30px;">
                                    <div id="tabContent0" class="tabContent0"
                                        style="font-size: 20px;font-weight: bold;text-align: left;">
                                        企业资质</div>


                                    <div style="display: flex; align-items: center; margin-top: 30px;">
                                        <div style="font-size: 14px;margin-right: 20px;width: 60px;">公司属地</div>
                                        <selectArea size="medium" placeholder="请选择公司注册地" level="area"
                                            @onCallBack="onCallBack" ref="selectAreasercher"
                                            :cascaderProps="cascaderProps"></selectArea>
                                    </div>

                                    <div style="display: flex; align-items: center; margin-top: 20px;">
                                        <div style="font-size: 14px;margin-right: 20px;width: 60px;">注册资金</div>
                                        <el-input clearable placeholder="请输入金额"
                                            oninput="value=value.replace(/^\.+|[^\d.]/g,'')" v-model="capital"
                                            style="width: 500px;">
                                            <template slot="prepend">>=</template>
                                            <template slot="append">万元</template>
                                        </el-input>
                                    </div>


                                    <div style="display: flex; align-items: center; margin-top: 20px;">
                                        <div style="font-size: 14px;margin-right: 20px;flex-shrink:0;width: 60px;">经营范围
                                        </div>
                                        <div style="display: flex;align-items: center;">
                                            <el-input maxlength="30" style="width: 500px;"
                                                placeholder="请输入经营范围，如：园林绿化，市政道路" v-model="scope"
                                                class="input-with-select" clearable>

                                            </el-input>
                                            <div style="flex-shrink:0">（字数限制：{{scope.length}}/30）</div>

                                        </div>
                                    </div>
                                    <div style="display: flex; align-items: center; margin-top: 20px;">
                                        <div style="font-size: 14px;margin-right: 20px;flex-shrink:0;width: 60px;">资质分类
                                        </div>
                                        <div style="display: flex;align-items: center;">

                                            <div style="flex-shrink:0;display: flex;">
                                                <span> （可添加多个资质条件，多个资质条件可选择</span> <span
                                                    style="color: #FF756B;">同时具备</span>或 <span
                                                    style="color: #FF756B;">任意均可）</span>
                                            </div>

                                        </div>
                                    </div>

                                    <div style="margin-left: 80px;text-align: left;margin-top: 20px;">

                                        <selectQua ref="selectQua" @backQuaValue="backQuaValue"></selectQua>

                                        <div
                                            style="display: flex; align-items: center; margin-top: 20px;font-size: 14px;">
                                            <div style="font-size: 14px;margin-right: 20px;">资质类别:</div>

                                            <div style="margin-right: 16px;" class="quaType"
                                                :class="quaTypeName==item&&'quaTypeActive'"
                                                v-for="(item,index) in qualifiTypeCate1"
                                                @click="slectQuType({item,index})" :key="index">{{item}}</div>
                                        </div>
                                        <!-- {{quaTypeName}} -->
                                        <div style="display: flex; align-items: center; margin-top: 20px;">
                                            <div style="font-size: 14px;margin-right: 20px;">资质名称:</div>
                                            <div style="margin-right: 10px;color: #007EF2;font-size: 14px;"
                                                class="quaType" @click="openQuaSelectBox">请选择资质包含名称</div>
                                        </div>



                                    </div>

                                    <div style="margin-left: 80px;margin-top: 20px;background: #FBFBFB;width: 800px;">
                                        <div style="display: flex;align-items: baseline;padding: 20px;font-size: 14px;">
                                            <div style="flex-shrink: 0;">复合条件：</div>
                                            <div style="display: flex;flex-wrap: wrap;">
                                                <div v-for="(item,index) in selectQuaList" :key="index"
                                                    style="background-color: #E7F4FF;padding:8px 10px ; border-radius: 20px; display: flex;margin-right: 10px;margin-bottom: 10px;">
                                                    <div>{{item.name}}</div>
                                                    <i class="el-icon el-icon-circle-close"
                                                        style="font-size: 20px;margin-left: 8px;"
                                                        @click="deleteItem({index,item})"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            style="display: flex;align-items: baseline;padding: 20px;font-size: 14px;padding-top: 20px;margin-top: 20px;border-top: solid 1px #E2E5EC;">
                                            <div style="flex-shrink: 0;">筛选形式：</div>
                                            <el-radio v-model="quaCondition" :label="0">同时具备</el-radio>
                                            <el-radio v-model="quaCondition" :label="1">任意均可</el-radio>
                                        </div>
                                    </div>

                                    <div style="display: flex;align-items: center;margin-left: 80px;margin-top: 20px;">
                                        <!-- <div class="reset" style="margin-right: 20px;">复合筛选</div> -->
                                        <div class="sure" @click="addCondtion('companyQua')">加入筛选</div>
                                    </div>



                                </div>
                                <div style="padding-top: 30px;border-top:solid 1px #E2E5EC ;">
                                    <div id="tabContent1" class="tabContent1"
                                        style="font-size: 20px;font-weight: bold;text-align: left;">
                                        企业业绩</div>
                                    <!-- <div style="display: flex;margin-top: 30px;">
                                        <div style="font-size: 14px;">业绩类型</div>
                                        <el-checkbox-group v-model="qualifiType">
                                            <el-checkbox v-for="(item,index) in qualifiTypeList" :label="item" :key="index">{{item}}</el-checkbox>
                                          </el-checkbox-group>
                                    </div> -->
                                    <div style="display: flex; align-items: center; margin-top: 30px;">
                                        <div style="font-size: 14px;margin-right: 20px;width: 60px;">业绩金额</div>
                                        <div style="display: flex;">
                                            <el-input placeholder="最小业绩金额" clearable
                                                v-model="performanceFormData.startAllinvest"
                                                oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                                                class="input-with-select">
                                                <div slot="append">
                                                    万元
                                                </div>
                                            </el-input>

                                            <el-input style="margin-left: 10px;" clearable placeholder="最大业绩金额"
                                                v-model="performanceFormData.endAllinvest"
                                                oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                                                class="input-with-select">
                                                <div slot="append">
                                                    万元
                                                </div>
                                            </el-input>
                                        </div>
                                    </div>
                                    <!-- <div style="display: flex; align-items: center; margin-top: 30px;">
                                        <div style="font-size: 14px;margin-right: 20px;width: 60px;">中标时间</div>
                                        <el-date-picker @change="changeTimeArray" value-format="yyyy-MM-dd" v-model="bidTimeArray" type="daterange" range-separator="至"
                                            start-placeholder="开始日期" end-placeholder="结束日期">
                                        </el-date-picker>
                                    </div> -->
                                    <div style="display: flex; align-items: center; margin-top: 20px;">
                                        <div style="font-size: 14px;margin-right: 20px;flex-shrink:0;width: 60px;">项目名称
                                        </div>
                                        <div style="display: flex;align-items: center;">
                                            <el-input maxlength="30" style="width: 500px;"
                                                placeholder="请输入项目名称包含的关键字，如：园林绿化，市政道路"
                                                v-model="performanceFormData.andPrjname" clearable
                                                class="input-with-select">

                                            </el-input>
                                            <div style="flex-shrink:0">
                                                （字数限制：{{performanceFormData.andPrjname?performanceFormData.andPrjname.length:0}}/30）
                                            </div>

                                        </div>
                                    </div>
                                    <div style="display: flex;align-items: center;margin-left: 80px;margin-top: 20px;">
                                        <!-- <div class="reset" style="margin-right: 20px;">复合筛选</div> -->
                                        <div class="sure" @click="addCondtion('performance')">加入筛选</div>
                                    </div>
                                </div>


                                <div style="padding-top: 30px;border-top:solid 1px #E2E5EC ;margin-top: 30px;">
                                    <div id="tabContent2" class="tabContent2"
                                        style="font-size: 20px;font-weight: bold;text-align: left;">
                                        企业人员</div>

                                    <div style="display: flex; align-items: center; margin-top: 20px;">
                                        <div style="font-size: 14px;margin-right: 20px;flex-shrink:0;width: 60px;">资质分类
                                        </div>
                                        <div style="display: flex;align-items: center;">

                                            <div style="flex-shrink:0;display: flex;">
                                                <span> （可添加多个资质条件，多个资质条件可选择</span> <span
                                                    style="color: #FF756B;">同时具备</span>或 <span
                                                    style="color: #FF756B;">任意均可）</span>
                                            </div>

                                        </div>
                                    </div>

                                    <div style="margin-left: 80px;text-align: left;margin-top: 20px;">
                                        <el-autocomplete style="width: 360px;" v-model="personTypeName"
                                            :fetch-suggestions="queryPersonAsync" placeholder="输入资质关键字，如：注册建筑师"
                                            @select="handleSelectPerson" clearable></el-autocomplete>
                                    </div>
                                    <div style="margin-left: 80px;margin-top: 20px;display: flex;">
                                        <el-select v-model="firstName" @change="personChange" placeholder="请选人员类别"
                                            style="margin-right: 20px;">
                                            <el-option v-for="(item,index) in personTypeList" :label="item.name"
                                                :value="item.name">
                                            </el-option>
                                        </el-select>
                                        <!--2 监理师-->
                                        <el-select v-if="firstName!='注册监理工程师'" v-model="secondTypeName"
                                            @change="selectSecondTypeName" placeholder="请选择">
                                            <el-option v-for="(item,index) in secondTypeList" :label="item.name"
                                                :value="item.name">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div style="margin-left: 80px;margin-top: 20px;background: #FBFBFB;width: 800px;">
                                        <div style="display: flex;align-items: baseline;padding: 20px;font-size: 14px;">
                                            <div style="flex-shrink: 0;">复合条件：</div>
                                            <div style="display: flex;flex-wrap: wrap;">
                                                <div v-for="(item,index) in selectPersonList" :key="index"
                                                    style="background-color: #E7F4FF;padding:8px 10px ; border-radius: 20px; display: flex;margin-right: 10px;margin-bottom: 10px;">
                                                    <div>{{item}}</div>
                                                    <i class="el-icon el-icon-circle-close"
                                                        style="font-size: 20px;margin-left: 8px;"
                                                        @click="deletePerson(index)"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            style="display: flex;align-items: baseline;padding: 20px;font-size: 14px;padding-top: 20px;margin-top: 20px;border-top: solid 1px #E2E5EC;">
                                            <div style="flex-shrink: 0;">筛选形式：</div>
                                            <el-radio v-model="personCondition" :label="0">同时具备</el-radio>
                                            <el-radio v-model="personCondition" :label="1">任意均可</el-radio>
                                        </div>
                                    </div>

                                    <div style="display: flex;align-items: center;margin-left: 80px;margin-top: 20px;">
                                        <!-- <div class="reset" style="margin-right: 20px;">复合筛选</div> -->
                                        <div class="sure" @click="addCondtion('person')">加入筛选</div>
                                    </div>
                                </div>

                                <div style="padding-top: 30px;border-top:solid 1px #E2E5EC ;margin-top: 30px;">
                                    <div id="tabContent3" class="tabContent3"
                                        style="font-size: 20px;font-weight: bold;text-align: left;">
                                        信用评级</div>

                                    <div style="display: flex;align-items: center;margin-left: 80px;margin-top: 20px;">
                                        <creditScore ref="creditScore" @creditBack="addCondtion('credit',$event)">
                                        </creditScore>
                                    </div>
                                </div>


                            </div>
                        </div>
                        <div class="queryBox" style="margin-left: 20px;flex: 1;">
                            <div class=""
                                style="display: flex;align-items: center;justify-content: space-between; font-size: 16px;border-bottom: 1px solid #E2E5EC;height: 60px;padding: 20px;">
                                <div style="font-size: 16px;font-weight: bold;">已筛选条件</div>

                                <div style="display: flex;align-items: center;">
                                    <div class="reset" style="margin-right: 20px;" @click="resetData()">重置</div>
                                    <div class="sure" @click="queryCheck">查询</div>
                                </div>
                            </div>
                            <div class="scrollViewY">
                                <div v-for="(item,index) in conditionList" :key="index">
                                    <template v-if="item.condtionType==='companyQua'">
                                        <div
                                            style="font-size: 20px;font-weight: bold;text-align: left;margin-top: 20px;">
                                            企业资质</div>
                                        <div style="padding: 20px;font-size: 16px;border-bottom: solid 1px  #E2E5EC;">
                                            <div style="display: flex;" v-if="item.address">
                                                <div style="color: #888888;">公司属地：</div>
                                                <div>{{item.address}}</div>
                                            </div>
                                            <div style="display: flex;margin-top: 20px;" v-if="item.capital">
                                                <div style="color: #888888;">注册资金：（大于或等于）</div>
                                                <div>{{item.capital||0}}万元</div>
                                            </div>
                                            <div style="display: flex;margin-top: 20px;" v-if="item.scope">
                                                <div style="color: #888888;">经营范围：</div>
                                                <div>{{item.scope||''}}</div>
                                            </div>

                                            <div style="display: flex;margin-top: 20px;"
                                                v-if="item.selectQuaList.length">
                                                <div style="color: #888888;flex-shrink: 0;margin-top: 10px;">资质分类：</div>
                                                <div style="background: #FBFBFB;padding: 10px;">
                                                    <div style="display: flex;align-items: baseline;">
                                                        <div style="color: #888888;flex-shrink: 0;">复合条件：</div>
                                                        <div style="display: flex;flex-wrap:wrap;">
                                                            <div style="margin-right: 10px;"
                                                                v-for="(citem,cindex) in item.selectQuaList"
                                                                :key="index">
                                                                {{citem.name}}</div>
                                                        </div>
                                                    </div>

                                                    <div style="display: flex;margin-top: 20px;">
                                                        <div style="color: #888888;">筛选形式：</div>
                                                        <div>{{quaCondition===0?'同时具备':'任意均可'}}</div>
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </template>
                                    <template v-if="item.condtionType==='performance'">
                                        <div
                                            style="font-size: 20px;font-weight: bold;text-align: left;margin-top: 20px;">
                                            企业业绩</div>
                                        <div style="padding: 20px;font-size: 16px;border-bottom: solid 1px  #E2E5EC;">
                                            <div style="display: flex;" v-if="item.endAllinvest">
                                                <div style="color: #888888;">业绩金额：</div>
                                                <div>{{item.startAllinvest}}万元-{{item.endAllinvest}}万元</div>
                                            </div>
                                            <div style="display: flex;margin-top: 20px;" v-if="item.andPrjname">
                                                <div style="color: #888888;">项目名称：</div>
                                                <div>{{item.andPrjname}}</div>
                                            </div>

                                        </div>
                                    </template>
                                    <template v-if="item.condtionType==='person'">
                                        <div
                                            style="font-size: 20px;font-weight: bold;text-align: left;margin-top: 20px;">
                                            企业人员</div>
                                        <div style="padding: 20px;font-size: 16px;border-bottom: solid 1px  #E2E5EC;">
                                            <!-- <div style="display: flex;">
                                                <div style="color: #888888;">人员分类：</div>
                                                <div>{{item.typeName}}</div>
                                            </div> -->

                                            <div style="display: flex;" v-if="selectPersonList.length">
                                                <div style="color: #888888;flex-shrink: 0;margin-top: 10px;">人员分类：</div>
                                                <div style="background: #FBFBFB;padding: 10px;">
                                                    <div style="display: flex;align-items: baseline;">
                                                        <div style="color: #888888;flex-shrink: 0;">复合条件：</div>
                                                        <div style="display: flex;flex-wrap:wrap;">
                                                            <div style="margin-right: 10px;"
                                                                v-for="(citem,cindex) in selectPersonList" :key="index">
                                                                {{citem}}</div>
                                                        </div>
                                                    </div>

                                                    <div style="display: flex;margin-top: 20px;">
                                                        <div style="color: #888888;">筛选形式：</div>
                                                        <div>{{personCondition===0?'同时具备':'任意均可'}}</div>
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </template>

                                    <template v-if="item.condtionType==='credit'">
                                        <div
                                            style="font-size: 20px;font-weight: bold;text-align: left;margin-top: 20px;">
                                            信用评级</div>
                                        <div style="padding: 20px;font-size: 16px;border-bottom: solid 1px  #E2E5EC;">
                                            <div style="display: flex;">
                                                <div style="color: #888888;">查询省份：</div>
                                                <div>{{item.fromProvince}} {{item.fromCity?'-'+item.fromCity:''}}</div>
                                            </div>
                                            <div style="display: flex;margin-top: 20px;">
                                                <div style="color: #888888;">评分单位类型：</div>
                                                <div>{{item.subjectSpeciality2||item.subjectSpeciality||item.publicityType}}</div>
                                            </div>
                                            <div style="display: flex;margin-top: 20px;"
                                                v-if="item.endScore||item.creditGrade">
                                                <div style="color: #888888;">{{item.creditGrade?'信用评级：':'信用分数：'}} </div>
                                                <div v-if="item.endScore">{{item.startScore}}-{{item.endScore}}分</div>
                                                <div v-if="item.creditGrade">{{item.creditGrade}}</div>
                                            </div>
                                            <div style="display: flex;margin-top: 20px;" v-if="item.year">
                                                <div style="color: #888888;">评分期数：</div>
                                                <div>{{item.year}}-{{item.quarter}}</div>

                                            </div>
                                        </div>
                                    </template>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
                <!-- 
                <div v-loading="loadingStatus" style="margin-top: 20px;">

                    <div style="text-align: left;margin-bottom: 20px;">
                        <span style="font-size: 20px;font-weight: bold;">共<span
                                style="color:#DC5800 ;">{{total}}</span>条项目数据</span>
                    </div>


                    <el-table border :data="tableData" :header-cell-style=" { background: '#F8F8F8' }">
                        <el-table-column type="index" label="序号" width="80" align="center"
                            label-class-name="table-col-header-label">
                            <template slot-scope="{ $index }">
                                <span>{{ computeIndex($index, currentPage, size) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column header-align="center" align="center" label="社会统一信用代码" prop="creditCode"
                            width="200" min-width="200" label-class-name="table-col-header-label">
                        </el-table-column>


                        <el-table-column header-align="name" align="center" label="企业名称" prop="name"
                            label-class-name="table-col-header-label">
                            <template slot-scope="{ row }">
                                <span @click="goDetail(row)"
                                    style="text-decoration: underline;color: #2180EF; cursor: pointer;">{{row.name}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column header-align="name" align="center" label="企业注册属地" prop="address"
                            label-class-name="table-col-header-label">
                            <template slot-scope="{ row }">
                                <div>{{row|showCity()}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column header-align="name" align="center" label="企业资质类型" prop="qualification"
                            label-class-name="table-col-header-label">
                            <template slot-scope="{ row }">
                                <span class="hideline1">{{row.qualification}}</span>
                            </template>
                        </el-table-column>

                    </el-table>
                    <div style="text-align: right; margin-top: 20px;margin-bottom: 20px;">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 50, 100]" :page-size="size"
                            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
                    </div>
                </div> -->

            </div>
        </div>



        <quaDialog ref="quaDialog" :selectQuaList="selectQuaList"
            :categoryOptions="qualifiTypeCate1.filter(item=>item!='全部')" @confirm="quaConfirm">
        </quaDialog>
    </div>

</template>

<script>



    import { getAppidIsTree, getCommonQualificationTypes, compositePage } from "@/api/bid.js"
    import selectArea from "@/components/select-area/index.vue";
    // import BannerTitleItem from '../components/banner-title-item/index.vue'
    import selectQua from '@/components//select-qua/index.vue'
    import quaDialog from "@/components/qualification-dialog";
    import creditScore from './componets/creditScore'
    export default {
        components: {
            // BannerTitleItem,
            selectArea,
            selectQua,
            quaDialog,
            creditScore
        },
        data() {
            return {
                radio: 1,
                typeList: [{ name: '企业资质', value: '' }, { name: '企业业绩', value: '' }, { name: '企业人员', value: '' }, { name: '信用评级', value: '' }],
                typeIndex: 0,
                //地址组件
                cascaderProps: {
                    lazy: false,
                    value: "adCode",
                    label: "name",
                    children: "child",
                    expandTrigger: "hover",
                    emitPath: true,
                    checkStrictly: true,
                },
                //资质搜索相关---start
                qualifiTypeCate1: [],
                quaTypeName: '全部',
                selectQuaList: [],//选中的专业资质
                province: '',
                capital: '',
                city: '',
                county: '',
                province: '',
                scope: '',
                quaCondition: 0,//0 同时具备 1任意均可
                //资质搜索相关---end

                //企业业绩
                performanceFormData: {
                    startAllinvest: null,
                    endAllinvest: null,
                    andPrjname: null,

                },
                //人员资质---start
                timeout: null,
                allPersonType: [],
                personTypeList: [],
                personIndex: '',
                secondTypeList: [],
                personTypeName: '',
                secondTypeName: '',
                firstName: '',
                personCondition: 0,
                selectPersonList: [],
                //人员资质---end

                //信用分
                scoreReqVO: {
                    creditGrade: '',
                    endScore: '',
                    fromCity: '',
                    fromProvince: '',
                    quarter: '',
                    startScore: '',
                    subjectSpeciality: '',
                    year: '',
                },
                personQualifi: '',
                personQualifiList: [],
                //中标时间
                bidTimeArray: [],
                qualifiType: [],
                qualifiTypeList: ['不限', '四库一平台', '公共资源', '政府采购', '央企招标', '其他'],

                conditionList: [],//条件列表

                loadingStatus: false,
                tableData: [],
                total: 0,
                currentPage: 1,
                size: 10,
                scrollViewY: ''
            };
        },

        filters: {
            //数据问题只能写死判断 可能还有其他奇怪的名称
            showCity(item) {

                if (item.province === '北京市省' || item.province === '北京市') {
                    return '北京市' + (item.county ? '-' + item.county : '')
                } else if (item.province === '天津市省' || item.province === '天津市') {
                    return '天津市' + (item.county ? '-' + item.county : '')
                } else if (item.province === '重庆市省' || item.province === '重庆市') {
                    return '重庆市' + (item.county ? '-' + item.county : '')
                } else if (item.province === '上海市省' || item.province === '上海市') {
                    return '上海市' + (item.county ? '-' + item.county : '')
                } else {
                    return item.province + (item.city ? '-' + item.city : '') + (item.county ? '-' + item.county : '')
                }
            },
            showSelectCity() {

            },
        },
        created() {
            this.getAppidIsTree()
            this.getQuaType()
        },
        mounted() {
            // this.queryAll()
        },
        methods: {
            selectType({ item, index }) {
                this.typeIndex = index
                let elid = 'tabContent' + index
                let target = document.getElementById(elid);
                // target.scrollIntoView({
                //     behavior: 'smooth',
                //     block: 'start' // 滚动到目标元素顶部
                // });
                window.scrollTo(0, target.offsetTop - 80)

                // let parent = document.getElementById('scrollViewY');
                // parent.scrollTop = target.offsetTop - parent.offsetTop;
            },
            goDetail(item) {
                console.log('item', item)
                this.$router.push({
                    path: '/qualification/detail',
                    query: { unicode: item.creditCode, },
                });
            },
            computeIndex(index, page, pageSize) {
                return index + 1 + (page - 1) * pageSize;
            },
            handleSizeChange(val) {
                this.size = val
                this.queryAll();
            },
            handleCurrentChange(val) {
                this.currentPage = val
                this.queryAll();
            },
            //重置
            resetData() {
                //右侧列表查询条件
                this.conditionList = []
                //资质
                this.$refs.selectAreasercher.value = []
                this.$refs.selectQua.personQualifi = ''
                this.$refs.quaDialog.handleReset()
                this.province = ''
                this.city = ''
                this.county = ''
                this.capital = ''
                this.scope = ''
                this.selectQuaList = []
                this.quaCondition = 0
                //业绩
                this.performanceFormData.andPrjname = null
                this.performanceFormData.startAllinvest = null
                this.performanceFormData.endAllinvest = null
                //人员
                this.personIndex = ''
                this.secondTypeList = []
                this.personTypeName = ''
                this.personCondition = 0
                this.selectPersonList = []
                this.firstName = ''
                this.secondTypeName = ''
                //信用分
                this.scoreReqVO.creditGrade = ''
                this.scoreReqVO.endScore = ''
                this.scoreReqVO.fromCity = ''
                this.scoreReqVO.fromProvince = ''
                this.scoreReqVO.quarter = ''
                this.scoreReqVO.startScore = ''
                this.scoreReqVO.subjectSpeciality = ''
                this.scoreReqVO.year = ''

                this.$refs.creditScore.retSetAllData()
                // this.currentPage = 1
                // this.size = 20
                // this.queryAll()

            },
            queryCheck() {
                if (!this.conditionList.length) return this.$message({
                    message: '请选择查询条件!',
                    type: 'warning',
                })
                this.queryAll()
            },
            //开始查询
            async queryAll() {
                try {

                    //资质
                    let quanReqVO = {}
                    let province = ''
                    let city = ''
                    let county = ''
                    let scope = ''
                    let capital = ''
                    let quIndex = this.conditionList.findIndex(item => item.condtionType === 'companyQua')
                    if (quIndex != -1) {
                        let quObj = this.conditionList[quIndex]
                        province = quObj.province
                        city = quObj.city
                        county = quObj.county
                        scope = quObj.scope
                        capital = quObj.capital
                        let quaList = quObj.selectQuaList.map(item => {
                            return item.name
                        })
                        if (quObj.quaCondition === 0) {
                            quanReqVO.andNameList = quaList
                        } else {
                            quanReqVO.orNameList = quaList
                        }
                    }
                    //业绩 注意业绩金额 这个格式不能是空字符 
                    let projectInfoVO = {
                        orPrjname: [],//任意
                        startAllinvest: null,
                        endAllinvest: null,
                    }
                    let projectIndex = this.conditionList.findIndex(item => item.condtionType === 'performance')
                    if (projectIndex != -1) {
                        let performanceObj = this.conditionList[projectIndex]
                        projectInfoVO.orPrjname = performanceObj.andPrjname ? [performanceObj.andPrjname] : []
                        projectInfoVO.startAllinvest = performanceObj.startAllinvest || null
                        projectInfoVO.endAllinvest = performanceObj.endAllinvest || null
                    }

                    //人员
                    let personVO = {

                    }
                    let personIndex = this.conditionList.findIndex(item => item.condtionType === 'person')
                    if (personIndex != -1) {
                        let personObj = this.conditionList[personIndex]
                        if (personObj?.selectPersonList?.length) {

                            if (this.personCondition === 0) {
                                personVO.andTypeNames = personObj.selectPersonList
                            } else {
                                personVO.orTypeNames = personObj.selectPersonList
                            }

                        }
                    }
                    let scoreReqVO = {}

                    let {
                        creditGrade,
                        endScore,
                        fromCity,
                        fromProvince,
                        quarter,
                        startScore,

                        year,
                        publicityType,
                        subjectSpeciality,
                        subjectSpeciality2,
                    } = this.scoreReqVO
                    scoreReqVO = {
                        creditGrade,
                        endScore,
                        fromCity,
                        fromProvince,
                        quarter,
                        startScore,
                        publicityType,
                        subjectSpeciality,
                        subjectSpeciality2,
                        year,
                    }
                    let params = {
                        // current: this.currentPage,
                        // size: this.size,
                        province: province,
                        city: city,
                        county: county,
                        scope: scope,
                        capital: capital,
                        quanReqVO,
                        projectInfoVO,
                        personVO,
                        scoreReqVO,

                    }
                    // this.loadingStatus = true
                   
                    this.$router.push({ path: '/combinedQuery/combinedList', query: { params: params } })
                    // let { data } = await compositePage(params)

                    // this.tableData = data.records
                    // this.total = data.total
                    this.loadingStatus = false
                } catch (error) {
                    this.loadingStatus = false
                    console.log('=======error查询异常', error)

                }
            },
            //加入左侧组合查询
            addCondtion(type, creditFrom) {
                let index = this.checkList(type)
                switch (type) {
                    case 'companyQua':

                        let obj = {
                            condtionType: type,
                            province: this.province,
                            city: this.city,
                            county: this.county,
                            address: this.province + (this.city ? '-' + this.city : '') + (this.county ? '-' + this.county : ''),
                            scope: this.scope,
                            selectQuaList: JSON.parse(JSON.stringify(this.selectQuaList)),
                            quaCondition: this.quaCondition,
                            capital: this.capital,
                        }


                        if (this.checkObj(obj)) return this.$message({
                            message: '请添加查询条件!',
                            type: 'warning',
                            center: true
                        });
                        if (index === -1) {
                            this.conditionList.push(obj)
                        } else {
                            this.$set(this.conditionList, index, obj)
                        }

                        break;

                    case 'performance':
                        let performanceObj = {
                            condtionType: type,
                            startAllinvest: this.performanceFormData.startAllinvest,
                            endAllinvest: this.performanceFormData.endAllinvest,
                            andPrjname: this.performanceFormData.andPrjname
                        }
                        if (!this.performanceFormData.startAllinvest && !this.performanceFormData.endAllinvest && !this.performanceFormData.andPrjname) return this.$message({
                            message: '请添加查询条件!',
                            type: 'warning',
                            center: true
                        });
                        if (this.performanceFormData.startAllinvest && (!this.performanceFormData.endAllinvest || this.performanceFormData.endAllinvest === 0)) {
                            let message = !this.performanceFormData.endAllinvest ? '请完善金额!' : '请输入正确的金额!'
                            return this.$message({
                                message: message,
                                type: 'warning',
                                center: true
                            });
                        }
                        if (this.performanceFormData.endAllinvest && (!this.performanceFormData.startAllinvest && this.performanceFormData.startAllinvest !== 0)) {

                            return this.$message({
                                message: '请完善金额!',
                                type: 'warning',
                                center: true
                            });
                        }
                      
                        if (this.performanceFormData.endAllinvest&&this.performanceFormData.endAllinvest <= this.performanceFormData.startAllinvest) {
                            return this.$message({
                                message: '最小金额不能大于最大金额!',
                                type: 'warning',
                                center: true
                            });
                        }

                        if (index === -1) {
                            this.conditionList.push(performanceObj)
                        } else {
                            this.$set(this.conditionList, index, performanceObj)

                        }

                        break;

                    case 'person':
                        let personObj = {
                            condtionType: type,
                            selectPersonList: this.selectPersonList.length ? JSON.parse(JSON.stringify(this.selectPersonList)) : []
                        }
                        if (!personObj.selectPersonList.length) return this.$message({
                            message: '请添加查询条件!',
                            type: 'warning',
                            center: true
                        });
                        if (index === -1) {
                            this.conditionList.push(personObj)
                        } else {
                            this.$set(this.conditionList, index, personObj)

                        }

                        break;

                    case 'credit':

                        console.log('credit----', creditFrom)
                        let credit = {
                            condtionType: type,
                            creditGrade: creditFrom.creditGrade,
                            endScore: creditFrom.endScore,
                            fromCity: creditFrom.fromCity,
                            fromProvince: creditFrom.fromProvince,
                            quarter: creditFrom.quarter,
                            startScore: creditFrom.startScore,
                            publicityType: creditFrom.publicityType,
                            subjectSpeciality: creditFrom.subjectSpeciality,
                            subjectSpeciality2: creditFrom.subjectSpeciality2,
                            year: creditFrom.year,
                        }
                        this.scoreReqVO = { ...creditFrom }

                        if (index === -1) {
                            this.conditionList.push(credit)
                        } else {
                            this.$set(this.conditionList, index, credit)

                        }

                        break;


                    default:
                        break;
                }
            },
            //校验存在
            checkList(type) {
                let index = this.conditionList.findIndex(item => item.condtionType === type)
                return index
            },
            checkObj(obj) {
                let value = Object.values(obj)
                let valueLength = value.filter(item => item != '')

                if (valueLength.length === 1) {
                    return true
                } else {
                    return false
                }
            },
            //企业资质---start
            quaConfirm({ memorySelected }) {
                memorySelected.forEach(item => {
                    let index = this.selectQuaList.findIndex(citem => citem.name === item.name)
                    if (index === -1) {
                        this.selectQuaList.push(item)
                    }
                })


            },
            //删除资质
            deleteItem({ index, item }) {
                this.selectQuaList.splice(index, 1)
                this.$refs.quaDialog.deleteItem({ index, item })
            },
            //打开选择窗口
            openQuaSelectBox() {
                this.$refs.quaDialog.category = this.quaTypeName === '全部' ? '' : this.quaTypeName
                this.$refs.quaDialog.dialogVisible = true
                this.$refs.quaDialog.setOpen()
            },
            //输入搜索框 返回资质类别
            backQuaValue(item) {
                let subString = item.name.split(/甲级|乙级|丙级|丁级|甲（Ⅰ）级|甲（Ⅱ）级|特级|一级|二级|三级/)
                let sublength = subString[0].length
                let levelName = subString[0]
                let subStringLevel = item.name.substr(sublength, subString.length)
                console.log('levelName', levelName, subStringLevel)
                for (let i = 0; i < this.selectQuaList.length; i++) {
                    if (this.selectQuaList[i].name.includes(levelName) && this.selectQuaList[i].name != item.name) {

                        return this.$message.warning("同种专业,等级不能多选!");
                    }
                }
                item.select = true
                let index = this.selectQuaList.findIndex(citem => citem.name === item.name)
                if (index === -1) {
                    this.selectQuaList.push(item)
                }

                console.log('====this.selectQuaList', this.selectQuaList)
            },
            //选择一级类型
            slectQuType({ item, index }) {
                this.quaTypeName = item

                console.log('=this.quaTypeName', this)
            },
            //获取一级资质类型
            async getQuaType() {
                try {
                    let { data } = await getCommonQualificationTypes();
                    this.qualifiTypeCate1 = ['全部'].concat(data || [])
                    console.log('资质类型', data)
                } catch (error) {

                }
            },
            //选择人员资质
            handleSelectPerson(item) {

                let index = this.selectPersonList.findIndex(citem => citem === item.name)
                if (index === -1) {
                    this.selectPersonList.push(item.name)
                }
                console.log('=======item', item.name)
            },
            //二级选择
            selectSecondTypeName(typeName) {
                let index = this.selectPersonList.findIndex(citem => citem === typeName)
                if (index === -1) {
                    this.selectPersonList.push(typeName)
                }
            },
            personChange(val) {
                this.firstName = val
                this.secondTypeName = ''
                this.personIndex = val
                let index = this.personTypeList.findIndex(item => item.name === val)
                this.secondTypeList = this.personTypeList[index].child
                let cindex = this.selectPersonList.findIndex(citem => citem === val)
                if (cindex === -1) {
                    this.selectPersonList.push(val)
                }


            },
            deletePerson(index) {
                this.selectPersonList.splice(index, 1)
                this.secondTypeName = ''
                this.firstName = ''
                this.secondTypeList = []
            },
            //获取人员资质类别
            async getAppidIsTree() {
                try {
                    let { data } = await getAppidIsTree({ appid: 'wxbd94b37dd45c1f91' })
                    let list = data.filter(item => item.label == '人员类别')
                    let allList = []
                    list.forEach((item) => {
                        if (item?.child?.length) {
                            item.child.forEach((citem) => {
                                citem.value = citem.name
                                allList.push(citem)
                            })

                        }
                    })
                    this.allPersonType = allList
                    this.personTypeList = list
                } catch (error) {

                }
            },
            //搜索远端数据
            queryPersonAsync(queryString, cb) {
                try {
                    let results = this.allPersonType.filter(item => item.name.includes(queryString))
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        cb(results);
                    }, 1000 * Math.random());
                    cb(data.records)
                } catch (error) {

                }

            },



            //地址回调
            onCallBack(e) {
                console.log("====e", e);
                if (e.length === 1) {

                    this.province = e[0].name;
                    this.city = "";
                    this.county = "";

                } else if (e.length === 2) {
                    this.province = e[0].name;
                    this.city = e[1].name;
                    this.county = "";
                } else if (e.length === 3) {
                    this.province = e[0].name;
                    this.city = e[1].name;
                    this.county = e[2].name;

                } else if (e.length === 0) {
                    this.province = "";
                    this.city = "";
                    this.county = "";
                }
            },

            //时间触发
            changeTimeArray(e) {
                console.log('=======time', e)
            },

        },
    };
</script>

<style scoped>
    .tab-center {
        position: fixed;
        top: 300px;
        left: 20px;
    }

    .home-banner-bg {
        position: relative;
        background-image: url("~@/assets/images/enterprise/query_bg.png");
        height: 200px;
        width: 100%;
        padding-top: 80px;
    }

    .queryBox {
        border: 1px solid #E2E5EC;

    }

    .bottomTab {
        position: absolute;
        bottom: 0;
        text-align: center;
    }

    .normal {
        margin-bottom: 10px;
        border: solid 1px #888888;
    }

    .active {
        color: #1890FF;
        border: solid 1px #1890FF;
        /* border-bottom: solid 3px #1890FF; */

    }

    .reset {
        border-radius: 2px 2px 2px 2px;
        opacity: 1;
        border: 1px solid #1890FF;
        color: #1890FF;
        padding: 8px 26px;
        font-size: 14px;
        cursor: pointer;
    }

    .sure {
        color: #FFFFFF;
        background: #1890FF;
        border-radius: 2px 2px 2px 2px;
        padding: 8px 26px;
        font-size: 14px;
        cursor: pointer;
    }

    .scrollViewY {
        overflow: hidden;
        overflow: scroll;
        overflow-x: hidden;
        /* height: 500px; */

        padding: 20px;
    }

    .scrollViewY::-webkit-scrollbar {
        width: 10px;

    }

    .scrollViewY::-webkit-scrollbar-thumb {
        background: #888888;
        border-radius: 30px;
    }

    .red {
        color: #EE1E1E;
        width: 6px;
        height: 6px;
        padding-top: 2px;
        margin-left: 8px;
        margin-right: 20px;
    }

    .quaType {

        cursor: pointer;
    }

    .quaType:hover {
        color: #1890FF;

    }

    .quaTypeActive {
        padding: 8px 10px;
        background: #edf4ff;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        color: #007EF2;
    }

    ::v-deep .table-col-header-label {
        font-size: 16px;
        font-family: Source Han Sans CN-Regular;
        font-weight: 500;
        color: #4e4e4e;
        text-align: center;
    }

    .link-in-row.el-link.el-link--default {
        font-size: 16px;
    }

    .link-in-row.el-link.el-link--default:hover {
        color: #007ef2;
    }

    ::v-deep .el-table--enable-row-transition .el-table__body td.el-table__cell {
        font-size: 16px !important;
    }

    .hideline1 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>